var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('v-btn',{staticClass:"mx-1",attrs:{"small":"","color":"primary","loading":_vm.loading},on:{"click":_vm.approve}},[_c('v-icon',{attrs:{"small":"","left":""}},[_vm._v("mdi-check")]),_vm._v("approve ")],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }